import { useEffect, useMemo, useState } from "react";

const usePageShipmentSelection = (items = []) => {
  const [selectedShipmentIds, setSelectedShipmentIds] = useState([]);
  const pageShipmentIds = useMemo(
    () => items.map(item => item?.id).filter(id => id !== null && id !== undefined),
    [items]
  );

  useEffect(() => {
    const pageIdSet = new Set(pageShipmentIds);
    setSelectedShipmentIds(currentIds => currentIds.filter(id => pageIdSet.has(id)));
  }, [pageShipmentIds]);

  const toggleShipment = (shipmentId) => {
    setSelectedShipmentIds(currentIds =>
      currentIds.includes(shipmentId)
        ? currentIds.filter(id => id !== shipmentId)
        : [...currentIds, shipmentId]
    );
  };

  const selectAllOnPage = () => setSelectedShipmentIds(pageShipmentIds);
  const clearSelection = () => setSelectedShipmentIds([]);
  const allPageSelected = pageShipmentIds.length > 0 && pageShipmentIds.every(id => selectedShipmentIds.includes(id));

  return {
    selectedShipmentIds,
    toggleShipment,
    selectAllOnPage,
    clearSelection,
    allPageSelected,
  };
};

export default usePageShipmentSelection;
